import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import IdleTimerContainer from '../util/IdleTimerContainer';
import PrivateRoute from '../util/PrivateRoute';
import routeConfig from './routeConfig';

const Routes = () => {
  const location = useLocation();
  const history = useHistory();
  const batchName = location?.state?.batchName ? location?.state?.batchName : '';
  const queryParams = new URLSearchParams(location.search);
  const path = queryParams.get('path');

  useEffect(() => {
    sessionStorage.removeItem('modifiedWindowsFields');
  }, []);

  useEffect(() => {
    if (location.pathname === '/account-summary') {
      sessionStorage.setItem('batchName', batchName);
    } else {
      sessionStorage.removeItem('batchName');
    }
  }, [location?.pathname, batchName]);

  useEffect(() => {
    window.addEventListener('message', function (e) {
      if (e.origin !== process.env.REACT_APP_WELLFUND_APP) return;
      const data = JSON.parse(e.data);
      sessionStorage.setItem('token', data.authToken);
      if (sessionStorage.getItem('token')) {
        history.push({
          pathname: `/account-summary`,
          state: { accountNumber: data.accountNumber },
        });
      }
    });
  }, []);

  const authToken = sessionStorage.getItem('token');
  if (authToken && location.pathname === '/login') {
    return <Redirect to={'/account-summary'} />;
  }

  if (authToken && path === 'login') {
    return <Redirect to={'/account-summary'} />;
  }

  if (authToken && location.pathname === '/') {
    return <Redirect to={'/account-summary'} />;
  }

  if (!authToken && location.pathname === '/') {
    return <Redirect to={'/login'} />;
  }

  if (path) {
    const matchedRoute = routeConfig.find((route) => route.path === path);
    if (matchedRoute) {
      return <Redirect to={`/${path}`} />;
    }
  }

  return (
    <React.Fragment>
      <Switch>
        {routeConfig.map((route, index) => {
          const routePath = `/${route.path}`;
          if (route.isPrivate) {
            return <PrivateRoute key={index} path={routePath} component={route.component} />;
          }
          return <Route key={index} path={routePath} component={route.component} />;
        })}
      </Switch>
      {authToken && <IdleTimerContainer></IdleTimerContainer>}
    </React.Fragment>
  );
};

export default Routes;
